//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is
the property of 6over6 Ltd. and its licensors. Any use of the Software is
strictly prohibited unless an explicit license or permission is granted by
6over6 Ltd.
<template>
  <section class="go_step_list_container">
    <div class="go_step_container" v-for="(step, index) in steps" :key="index">
      <div class="img_wrapper">
        <CircleIcon />
        <img :src="step.imgSrc" />
      </div>
      <div class="step_title">{{ step.title }}</div>
      <div class="go_description">
        {{ step.description }}
      </div>
    </div>
  </section>
</template>
<script setup>
import { useStore } from "vuex";
import { defineProps, ref } from "vue";
import CircleIcon from "@/components/icons/CircleIcon.vue";

const props = defineProps([
  "stepTestImg",
  "stepGetPrescriptionImg",
  "stepStartShopping",
]);
const store = useStore();

const steps = ref([
  {
    imgSrc: props.stepTestImg,
    title: store.state.page.steps_assets.step_test_title,
    description: store.state.page.steps_assets.step_test_description,
  },
  {
    imgSrc: props.stepGetPrescriptionImg,
    title: store.state.page.steps_assets.step_get_prescription_title,
    description:
      store.state.page.steps_assets.step_get_prescription_description,
  },
  {
    imgSrc: props.stepStartShopping,
    title: store.state.page.steps_assets.step_start_shopping_title,
    description: store.state.page.steps_assets.step_start_shopping_description,
  },
]);
</script>

<style lang="scss" scoped>
.go_step_list_container {
  display: flex;
  flex-direction: row;
  justify-content: center;

  height: 100%;

  @include mobile {
    flex-wrap: wrap;
  }

  .go_step_container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 50px;
    width: 314px;
    height: 100%;
    text-align: center;
    margin-right: 70px;
    &:last-child {
      margin-right: 0px;
    }

    @include tablet {
      height: 385px;
      width: 236px;
      margin-right: 60px;
      &:last-child {
        margin-right: 0px;
      }
    }

    @include mobile {
      height: 320px;
      width: 232px;
      margin-bottom: 60px;
      margin-right: 0px;

      &:last-child {
        margin-bottom: 0px;
      }
    }

    .img_wrapper {
      width: 217px;
      height: 217px;
      margin-bottom: 75px;
      display: flex;
      position: relative;
      justify-content: center;
      align-items: center;

      @include tablet {
        margin-bottom: 60px;
        width: 180px;
        height: 180px;
      }

      @include mobile {
        width: 180px;
        height: 180px;
        margin-bottom: 18px;
      }

      svg {
        width: 100%;
        height: 100%;
        display: inline-block;
        position: absolute;
        top: 0;
        left: 0;
      }

      img {
        width: 92%;

        @include tablet {
          width: 90%;
        }

        @include mobile {
          width: 90%;
        }
      }
    }

    .step_title {
      font-weight: 700;
      font-size: 24.3333px;
      line-height: 38px;
      margin-bottom: 22px;

      @include tablet {
        font-size: 20px;
        line-height: 31px;
        margin-bottom: 18px;
      }

      @include mobile {
        font-size: 20px;
        line-height: 31px;
        margin-bottom: 18px;
      }
    }

    .go_description {
      font-weight: 300;
      font-size: 17.0333px;
      line-height: 24px;
      width: 242px;

      @include tablet {
        font-size: 14px;
        line-height: 20px;
        width: 200px;
      }

      @include mobile {
        font-size: 14px;
        line-height: 20px;
        width: 216px;
      }
    }
  }
}
</style>
